import type { CheckboxChangeEvent } from "../../../../types"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { FaCheck } from "react-icons/fa"

/**
 * すべて選択チェックボックスコンポーネント
 * @param checked
 * @param onCheckedChange
 */
const AllSelectCheckBox = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (event: CheckboxChangeEvent) => void
}) => {
  const handleChange = (isChecked: boolean) => {
    const event: CheckboxChangeEvent = {
      target: {
        name: "selectAll",
        checked: isChecked,
        type: "checkbox",
      },
    }
    onCheckedChange(event)
  }

  return (
    <label className="flex w-40 cursor-pointer items-center rounded-lg bg-white p-2">
      <CheckboxPrimitive.Root
        name="selectAll"
        checked={checked}
        onCheckedChange={handleChange}
        className="h-6 w-6 shrink-0 rounded border-2 border-gray-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#51bc51] focus-visible:ring-offset-2 data-[state=checked]:border-[#51bc51] data-[state=checked]:bg-[#51bc51]"
      >
        <CheckboxPrimitive.Indicator className="flex items-center justify-center text-white">
          <FaCheck className="h-3 w-3" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className={`ml-2 text-base font-bold ${checked ? "text-[#32383e]" : "text-[#9fa6ad]"}`}>すべてを選択</span>
    </label>
  )
}

export default AllSelectCheckBox
